module.exports = __webpack_public_path__ + "static/img/CODY-TEMPLETON.5ed2ab2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/CODY-TEMPLETON.jpg
// module id = 5bH5
// module chunks = 0